import { Anchor, Image } from "@mantine/core";
import { format } from "date-fns";
import { PaperClipIcon } from "@/components/ui/elements";
import type {
  MessageAttachment,
  MessageImage,
} from "@/gql/__generated__/graphql";

import { MessageWithLinks } from "./MessageWithLinks";

type Props = {
  id: string;
  body: string;
  sentAt: string;
  isReceivedMessage: boolean;
  images: MessageImage[];
  attachments: MessageAttachment[];
};

export function MessageItem({
  id,
  body,
  sentAt,
  isReceivedMessage,
  images,
  attachments,
}: Props) {
  return (
    <>
      {(images.length || attachments.length || body) && (
        <div
          key={id}
          style={{
            marginBottom: "10px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {body && (
            <div
              style={{
                padding: "10px",
                backgroundColor: isReceivedMessage ? "#e0e0e0" : "#aedcff",
                borderRadius: "5px",
                alignSelf: isReceivedMessage ? "flex-start" : "flex-end",
                wordWrap: "break-word",
                wordBreak: "break-all",
                whiteSpace: "pre-wrap",
              }}
            >
              <MessageWithLinks body={body} />
            </div>
          )}
          {images.map((image) => (
            <div
              key={image.id}
              style={{
                marginTop: "5px",
                borderRadius: "5px",
                alignSelf: isReceivedMessage ? "flex-start" : "flex-end",
              }}
            >
              <Image src={image.file} alt="" />
            </div>
          ))}
          {attachments.map((attachment) => (
            <div
              key={attachment.id}
              style={{
                marginTop: "5px",
                alignSelf: isReceivedMessage ? "flex-start" : "flex-end",
              }}
            >
              <Anchor
                href={attachment.file}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px",
                  backgroundColor: isReceivedMessage ? "#e0e0e0" : "#aedcff",
                  borderRadius: "5px",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <PaperClipIcon size={"1.5rem"} />
                <span>
                  {attachment.originalFileName || "PDFファイル"}を開く
                </span>
              </Anchor>
            </div>
          ))}
          <div
            style={{
              fontSize: "0.8em",
              color: "#555",
              alignSelf: isReceivedMessage ? "flex-start" : "flex-end",
              marginTop: "5px",
            }}
          >
            {format(new Date(sentAt), "yyyy/MM/dd HH:mm")}
          </div>
        </div>
      )}
    </>
  );
}
